export const ALL_TOPIC = 'All topics';
export const FORM_STATES = {
	FORM: 'FORM',
	LOADING: 'LOADING',
	TECHNICAL_ERROR: 'TECHNICAL_ERROR',
	NO_RESULT: 'NO_RESULT'
};
